'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _Message = require('./Message');

var _Message2 = _interopRequireDefault(_Message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Messages = function Messages(_ref) {
  var height = _ref.height,
      messages = _ref.messages,
      showMediaElement = _ref.showMediaElement,
      styles = _ref.styles,
      baseUrl = _ref.baseUrl;

  return _react2.default.createElement(
    'div',
    { className: 'messagesContainer' },
    _react2.default.createElement(
      _reactAddonsCssTransitionGroup2.default,
      { transitionName: '__CHAT_TEMPLATE_MESSAGES_TRANSITION_ELEMENT', transitionEnterTimeout: 55000, transitionLeave: false },
      messages.map(function (message, i) {
        return _react2.default.createElement(_Message2.default, { key: i, height: height, message: message, showMediaElement: showMediaElement, baseUrl: baseUrl });
      })
    )
  );
};

Messages.propTypes = {
  height: _react.PropTypes.number,
  messages: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    message: _react.PropTypes.string,
    src: _react.PropTypes.string,
    inbound: _react.PropTypes.bool.isRequired,
    avatar: _react.PropTypes.string,
    backgroundColor: _react.PropTypes.string,
    color: _react.PropTypes.string
  })).isRequired,
  showMediaElement: _react.PropTypes.func,
  styles: _react.PropTypes.object,
  baseUrl: _react.PropTypes.string
};

exports.default = Messages;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Chat/Messages.js
// module id = 790
// module chunks = 0